import {  apiCallWithAuthWithReturn, handleResponseErrorData } from "../utils/commonUtils";

export const serviceFetchUserAddressDetails = async(params) =>{
    const {callType} = params;
    try {
        const data=JSON.stringify(params);
        const urlClinic= `${process.env.REACT_APP_API_URL}/init/checkProfile/userAddress`;
        const urlPatient= `${process.env.REACT_APP_API_URL}/auth/getPatientAddress`;
        return await apiCallWithAuthWithReturn(callType=='patient'?urlPatient:urlClinic,'POST',data,callType=='patient'?{token_type:'pat'}:{},null);
    } catch (error) {
        return handleResponseErrorData(error, null);
    }       
}

export const serviceFetchContactInfo = async(userId) =>{
  try {
      const data=JSON.stringify({user_id:userId});
      const url= `${process.env.REACT_APP_API_URL}/init/checkProfile/contactInfo`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  }       
}

export const serviceFetchUserBasicInfo = async(userId) =>{
  if(userId){
      try {
          const data=JSON.stringify({user_id:userId});
          const url= `${process.env.REACT_APP_API_URL}/init/checkProfile/userBasicInformation`;
          return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
        } catch (error) {
            return handleResponseErrorData(error, null);
        }       
    }
}

export const serviceFetchClinicId = async(clinicId)=>{
  try {
    const data=null
    const url= `${process.env.REACT_APP_API_URL}/Services/get?clinicId=${clinicId}`;
    return await apiCallWithAuthWithReturn(url,'Get',data,{},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
}

export const serviceDeleteServices = async(id)=>{
    try {
      const data=null
      const url= `${process.env.REACT_APP_API_URL}/Services/deleteservices?service_item_id=${id}`;
      return await apiCallWithAuthWithReturn(url,'Delete',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceGetClinicBasicDetails = async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/init/checkProfile/clinicBasicDetails`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceGetClinicContactDetails = async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/init/checkProfile/clinicContactDetails`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceGetClinicAddressDetails = async(params)=>{
    try {
        const data=JSON.stringify(params);
        const url= `${process.env.REACT_APP_API_URL}/init/checkProfile/clinicAddressDetails`;
        const response = await apiCallWithAuthWithReturn(url,'POST',data,{},null);
        if(response?.status){
            return response?.data;
        }
        return null;
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceGetclinicMsgCount = async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/clinicMsgCount`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdateClinicAddressInfo = async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updateClinicAddress`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdateClinicContactDetails = async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updateClinicContactDetails`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdateClinicBasicInfo = async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updateClinicBasicInformation`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdateBasicInfo = async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updateUser`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdateUserAddress= async(params)=>{
    const {callType} = params;
    try {
      const data=JSON.stringify(params);
      const urlClinic= `${process.env.REACT_APP_API_URL}/auth/updateUserAddress`;
      const urlPatient= `${process.env.REACT_APP_API_URL}/auth/updatePatientAddress`;
      return await apiCallWithAuthWithReturn(callType=='patient'?urlPatient:urlClinic,'POST',data,callType=='patient'?{token_type:'pat'}:{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdatePrimaryEmailRequest= async(params)=>{
    const {callType} = params;
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updatePrimaryEmailRequest`;
      return await apiCallWithAuthWithReturn(url,'POST',data,callType=='patient'?{token_type:'pat'}:{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceVerifyOtpAndUpdate= async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updatePrimaryEmail/verifyOtpAndUpdate`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdatePrimaryPhoneNumberRequest= async(params)=>{
    const {callType} = params;
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updatePrimaryPhoneNumberRequest`;
      return await apiCallWithAuthWithReturn(url,'POST',data,callType=='patient'?{token_type:'pat'}:{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceVerifyOtpPhoneUpdate= async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updatePrimaryPhoneNumber/verifyOtpAndUpdate`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdateClinicWhatsAppSetting= async(params)=>{
    try {
      const data=JSON.stringify(params);
      const url= `${process.env.REACT_APP_API_URL}/auth/updateClinicWhatsAppSetting`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceGetServiceDetailForClinic= async(serviceId)=>{
    try {
      const data=null;
      const url= `${process.env.REACT_APP_API_URL}/Services/service-managers?id=${serviceId}`;
      return await apiCallWithAuthWithReturn(url,'PUT',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceCopyClinicService = async(formData)=>{
    try {
      const data = JSON.stringify(formData);
      const url= `${process.env.REACT_APP_API_URL}/Services/createservices`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdateClinicService = async(formData)=>{
    try {
      const data = JSON.stringify(formData);
      const url= `${process.env.REACT_APP_API_URL}/Services/service-managers`;
      return await apiCallWithAuthWithReturn(url,'PUT',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}

export const serviceUpdateUserUsingUserId = async(formData)=>{
    try {
      const data = JSON.stringify(formData);
      const url= `${process.env.REACT_APP_API_URL}/auth/updateUserBasicInfo`;
      return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  } 
}
